import type { Components } from "@mui/material/styles";
import type { Theme } from "../types";
import type {} from "@mui/x-data-grid/themeAugmentation";

export const MuiDataGrid = {
  styleOverrides: {
    root: {
      border: 0,
      "& .MuiDataGrid-cell": {
        borderBottom: 0,
      },
      "& .MuiDataGrid-columnHeaders": {
        borderBottom: 0,
      },
    },
  },
} satisfies Components<Theme>["MuiDataGrid"];
